import * as actionConsts from './actions';
import * as actionConsts2 from '../Images/actions3';
import { SAVE_SIGNATURE_SUCCESS } from './Signature/actions';
import update from 'react/lib/update';

export const initState = {
  employeeSuggestions: [],
  employeeIsDragging: false,
  date: new Date(),
  isLoading: false,
  isShowingTimeRegistration: true,
  isSavingDailyReport: false,
  isEditMode: false,
  isEditSignature: false,
  approved: false,
  stamdata: {
    client: {},
    project: {},
    workplaceName: ""
  },
  emailSuggestions: [],
  dailyReportIsEdit: false,
  listOfDailyReports: [],
  currentDailyReportId: null,
  dailyReportIdLink: null,
  dailyReportEmployeeId: null,
  showEmailConfirmation: false,
  isSending: false,
  predefinedActivities: [],
  pics: [],
  isShowingDeleteModal: null
}


export default (state = initState, action) => {
  switch (action.type) {
    case actionConsts.DAILY_REPORT_GET_SUCCESS:
      return update(state, {
        isEditMode: {
          $set: !action.isEdit
        },
        approved: {
          $set: action.approved
        },
        isShowingTimeRegistration: {
          $set: true
        },
        stamdata: {
          $set: action.stamdata
        },
        dailyReportIsEdit: {
          $set: action.isEdit
        },
        isLoading: {
          $set: false
        },
        currentDailyReportId: {
          $set: action.currentDailyReportId
        },
        listOfDailyReports: {
          $set: action.listOfDailyReports
        },
        dailyReportIdLink: {
          $set: null
        },
        dailyReportEmployeeId: {
          $set: null
        },
        predefinedActivities: {
          $set: action.predefinedActivities
        },
        pics: {
          $set: action.pics
        }
      });
    case actionConsts.DAILY_REPORT_GET_FAILURE:
      return update(state, {
        isLoading: {
          $set: false
        }
      });
    case actionConsts.DAILY_REPORT_GET_REQUEST:
      return update(state, {
        isLoading: {
          $set: true
        }
      });
    case actionConsts.GET_EMPLOYEE_SUGGESTIONS_SUCCESS:
      return update(state, {
        employeeSuggestions: {
          $set: action.suggestions
        }
      });
    case actionConsts.DAILY_REPORT_SET_EMPLOYEE_IS_DRAGGING:
      return update(state, {
        employeeIsDragging: {
          $set: action.employeeIsDragging
        }
      });
    case actionConsts.SET_DAILY_REPORT_DATE:
      return update(state, {
        date: {
          $set: action.date
        },
        isEditSignature: {
          $set: false
        },
        dailyReportIdLink: {
          $set: action.dailyReportIdLink
        },
        dailyReportEmployeeId: {
          $set: action.dailyReportEmployeeId
        }
      });
    case actionConsts.SET_IS_SHOWING_TIME_REGISTRATION:
      return update(state, {
        isShowingTimeRegistration: {
          $set: action.bool
        }
      });
    case actionConsts.SAVE_DAILY_REPORT_REQUEST:
      return update(state, {
        isSavingDailyReport: {
          $set: true
        }
      });
    case actionConsts.SAVE_DAILY_REPORT_SUCCESS:
      return update(state, {
        isSavingDailyReport: {
          $set: false
        },
        isEditMode: {
          $set: false
        }
      });
    case actionConsts.DAILY_REPORT_TOGGLE_EDIT:
      return update(state, {
        isEditMode: {
          $set: action.bool
        }
      });
    case actionConsts.SAVE_DAILY_REPORT_FAILURE:
      return update(state, {
        isSavingDailyReport: {
          $set: false
        }
      });
    case actionConsts.DAILY_REPORT_TOGGLE_EDIT_SIGNATURE:
      return update(state, {
        isEditSignature: {
          $set: action.bool
        }
      });
    case SAVE_SIGNATURE_SUCCESS:
      return update(state, {
        isEditSignature: {
          $set: false
        }
      });
    case actionConsts.GET_EMAIL_SUGGESTIONS_SUCCESS:
      return update(state, {
        emailSuggestions: {
          $set: action.suggestions
        }
      });
    case actionConsts.SEND_EMAILS_REQUEST:
      return update(state, {
        isSending: {
          $set: true
        }
      });
    case actionConsts.SEND_EMAILS_SUCCESS:
      return update(state, {
        showEmailConfirmation: {
          $set: true
        },
        isSending: {
          $set: false
        }
      });
    case actionConsts.SET_SHOW_EMAIL_CONFIRMATION:
      return update(state, {
        showEmailConfirmation: {
          $set: false
        }
      });







    case actionConsts2.GET_IMAGES_SUCCESS:
      return update(state, {
        pics: {
          $set: action.images
        }
      });
    case actionConsts2.ADD_PICTURE:
      return update(state, {
        pics: {
          $splice: [[0, 0, action.pic]]
        }
      });
    case actionConsts2.UPDATE_PICTURE:
      return update(state, {
        pics: {
          [action.index]: {
            $set: action.pic
          }
        }
      });
    case actionConsts2.UPDATE_DESCRIPTION:
      return update(state, {
        pics: {
          [action.index]: {
            description: {
              $set: action.text
            }
          }
        }
      });
    case actionConsts2.SET_IS_SHOWING_DELETE_MODAL:
      return update(state, {
        isShowingDeleteModal: {
          $set: action.imageIndex
        }
      });
    case actionConsts2.DELETE_IMAGE_SUCCCESS:
      return update(state, {
        pics: {
          $splice: [[action.imageIndex, 1]]
        },
        isShowingDeleteModal: {
          $set: null
        }
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/reducer.js